(() => {
  const cursor = document.getElementById('starminer-pickaxe-cursor');
  if (!cursor || cursor.dataset.ready) return;
  cursor.dataset.ready = 'true';
  const root = document.documentElement;
  const icon = cursor.querySelector('svg');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const sparks = new Set();
  let swing;
  function hide() { root.classList.remove('starminer-pickaxe-active'); }
  function sync(event) {
    const target = event.target;
    if (!fine.matches || event.pointerType !== 'mouse' || !(target instanceof Element) ||
        target.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"]), iframe, video, model-viewer') || target.isContentEditable) {
      hide(); return false;
    }
    cursor.style.transform = `translate(${event.clientX - 3}px, ${event.clientY - 3}px)`;
    root.classList.add('starminer-pickaxe-active');
    return true;
  }
  function clearMotion() {
    swing?.cancel();
    for (const spark of sparks) spark.remove();
    sparks.clear();
  }
  document.addEventListener('pointermove', sync, { passive: true });
  document.addEventListener('pointerover', sync, { passive: true });
  root.addEventListener('pointerleave', hide);
  window.addEventListener('blur', () => { hide(); clearMotion(); });
  window.addEventListener('scroll', hide, { passive: true });
  document.addEventListener('keydown', hide);
  document.addEventListener('focusin', event => {
    if (event.target instanceof Element && event.target.closest('input, textarea, select, [contenteditable]')) hide();
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden) { hide(); clearMotion(); } });
  fine.addEventListener('change', () => { hide(); clearMotion(); });
  reduced.addEventListener('change', clearMotion);
  document.addEventListener('pointerdown', event => {
    if (event.button !== 0 || !sync(event) || reduced.matches || !icon.animate) return;
    swing?.cancel();
    swing = icon.animate([
      { transform: 'rotate(0deg)' },
      { transform: 'rotate(28deg)', offset: .3 },
      { transform: 'rotate(-20deg)', offset: .58 },
      { transform: 'rotate(0deg)' }
    ], { duration: 290, easing: 'ease-out' });
    if (sparks.size >= 48) return;
    for (let i = 0; i < 6; i++) {
      const spark = document.createElement('i');
      spark.className = 'starminer-cursor-spark';
      spark.setAttribute('aria-hidden', 'true');
      spark.style.left = event.clientX + 'px';
      spark.style.top = event.clientY + 'px';
      document.body.append(spark); sparks.add(spark);
      const angle = Math.PI * 2 * i / 6;
      const distance = 14 + Math.random() * 20;
      const animation = spark.animate([
        { transform: 'translate(0,0)', opacity: 1 },
        { transform: `translate(${Math.cos(angle)*distance}px,${Math.sin(angle)*distance+12}px) rotate(110deg)`, opacity: 0 }
      ], { duration: 360, easing: 'ease-out' });
      const remove = () => { spark.remove(); sparks.delete(spark); };
      animation.onfinish = remove;
      animation.oncancel = remove;
    }
  }, { passive: true });
})();
